import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const systemRoutes: MenuInterface[] = [
    {
        code: 'GestionRemonterBaseDeProdSurBaseTestVUP',
        route: [
            {
                content: 'system/system-duplicate-prod-database',
                focus: 'empty'
            }, 'content'
        ]
    }
];
